var map = {
	"./banhmi.png": 9133,
	"./boon.png": 2850,
	"./coffee.png": 6547,
	"./drink.png": 4879,
	"./friedrice.png": 8746,
	"./meat.png": 4407,
	"./meatball.png": 1431,
	"./milk.png": 4436,
	"./photo_not_found.png": 1581,
	"./salad.png": 567,
	"./sprroll.png": 4146,
	"./steamedrice.png": 5579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;